export const mockOpenOrders = [
    {
      displayOrderId: "ORD001",
      patientName: "John Doe",
      orderId: "12345",
      age: "45",
      sex: "M",
      modality: "CT",
      studyName: "Chest CT Scan",
      labName: "City Radiology Center",
      studyId: "2.25.3118583794435682678620534414467990721",
      emergency: false,
      labUserId: "LAB001",
      meddream_id: "1",
      username: "Test Rad 1"
    },
    
    {
      displayOrderId: "ORD002",
      patientName: "Jane Smith",
      orderId: "12346",
      age: "32",
      sex: "F",
      modality: "MRI",
      studyName: "Brain MRI",
      labName: "Metro Imaging",
      studyId: "2.25.276289644059578708952471162097392716359",
      emergency: false,
      labUserId: "LAB002",
      meddream_id: "1",
      username: "Test Rad 1"
    },
    {
      displayOrderId: "ORD003",
      patientName: "Tanisha Lillard",
      orderId: "12347",
      age: "58",
      sex: "F",
      modality: "X-Ray",
      studyName: "Chest X-Ray",
      labName: "Radiance Diagnostics",
      studyId: "1.2.840.113619.2.261.4.2147483647.1719323884.764567",
      emergency: false,
      labUserId: "LAB001",
      meddream_id: "1",
      username: "Test Rad 1"
    },
    {
      displayOrderId: "ORD005",
      patientName: "Cristine Hok Anon",
      orderId: "12354",
      age: "38",
      sex: "F",
      modality: "X-Ray",
      studyName: "X-RAY ELBOW",
      labName: "Radiance Diagnostics",
      studyId: "1.2.840.113564.200.31.102.75.62.208.20201210124934329.1033",
      emergency: false,
      labUserId: "LAB001",
      meddream_id: "1",
      username: "Test Rad 1"
    },
    {
      displayOrderId: "ORD004",
      patientName: "Michael Brown",
      orderId: "12349",
      age: "35",
      sex: "M",
      modality: "Ultrasound",
      studyName: "Abdominal USG",
      labName: "City Center",
      studyId: "1.3.6.1.4.1.14519.5.2.1.1188.2803.272546201471978974292888446466",
      emergency: false,
      labUserId: "LAB001",
      meddream_id: "1",
      username: "Test Rad 1"
    }
  
  ]; 